import { takeLatest, call, put } from 'redux-saga/effects'
import getCertificate from 'api/administration/certificates/Get'
import * as fromActions from 'store/actions/certificates.action'

async function getCertificateInfo(certificateId: number) {
  return await getCertificate(certificateId)
}

function* getCertificateEffectSaga(action: any) {
  try {
    const data = yield call(getCertificateInfo, action.payload)
    yield put(fromActions.Actions.getCertificateSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* getCertificateWatcherSaga() {
  yield takeLatest(fromActions.GET_ADMIN_CERTIFICATE, getCertificateEffectSaga)
}